// extracted by mini-css-extract-plugin
module.exports = {"root":"ForumIdFormatter_root__ULsgc"};